<template>
    <div class="container">
        <div class="row">
        <div class="col">Application for</div>
        </div>
        <div class="row mb-3">
            <div class="col-md-7"><h5 class="mb-0"><b>{{application.title}}</b></h5>
            <application-status :application_id="application.id"></application-status>
            </div>
            <div class="col-md-5 pt-2 pb-3">
              <update-status :user="user" :application="application"></update-status>
              </div>
          </div>
          
<div>
  <b-card no-body>
    <b-tabs v-model="tabIndex" card>
      <b-tab title="Application" title-link-class="darklink">
        <b-card-text><profile-application @changeTitle="ChangeTab()" :application="application" :user="user"></profile-application></b-card-text>
      </b-tab>
      <b-tab title="Documents" title-link-class="darklink">
          <b-card-text><documents :headless="true" :user="application.user"></documents></b-card-text>
        </b-tab>
      <b-tab title="Messages" title-link-class="darklink">
        <b-card-text><application-messages :application="application" :user="user"></application-messages></b-card-text>
      </b-tab>
      <b-tab title="Updates" title-link-class="darklink">
        <b-card-text><application-updates :application="application" :user="user"></application-updates></b-card-text>
      </b-tab>
      <b-tab title="Listing" title-link-class="darklink">
        <b-card-text><listing-tab @changeTitle="ChangeTab()" :application="application" :user="user"></listing-tab></b-card-text>
      </b-tab>
    </b-tabs>
  </b-card>
</div>     
    </div>

</template> 

<script>
export default {
  props: ["user","application","tab"],

  data() {
    return {
      tabIndex: 0,
    };
  },

  mounted() { 

    
  },

  created() {

    this.tabIndex = this.tab;

  },

  methods: {

    ChangeTab() {
      this.tabIndex = 2;
    },


  },
};
</script>

<style scoped>

.online{ color: #00a037;}
.offline{ color: #c04141;}
.form-control {font-size: 0.85rem;}

</style>